import api from "api";
import { useMutation } from "react-query";

export type Position = "none" | "standing" | "sitting" | "lying";

export interface Vars {
  exerciseId: number;
  level: any;
  position: Position | null | undefined;
}

export const usePutLevelPosition = () =>
  useMutation((data: Vars) => {
    const position = data.position === "none" ? undefined : data.position;
    const { translations, image_url, video, ...levelData } = data.level;

    // @ts-ignore
    return api(`PUT /exercises/${data.exerciseId}/levels/${data.level.id}`, {
      root: process.env.REACT_APP_API_URL_V2 + "/v2/support",
      data: {
        ...levelData,
        position,
      },
    });
  });
